<script setup lang="ts">
  import { computed } from 'vue';
  import { textEllipsisClass } from '@tundr/theme';
  import {
    dataItemWrapperClass,
    dataItemLabelClass,
    dataItemValueClass,
  } from './DataItem.css.ts';
  import Tooltip from '../Tooltip/Tooltip.vue';

  type DataItemProps = {
    id?: string;
    testId?: string;
    title?: string;
    label: string;
    value?: string | number;
    wrapValue?: boolean;
  };

  const props = withDefaults(defineProps<DataItemProps>(), {
    wrapValue: false,
  });

  const valueClasses = computed(() => ({
    [dataItemValueClass]: true,
    [textEllipsisClass]: props.wrapValue,
  }));

  const displayValue = computed(() => props.value || '-');
</script>

<template>
  <div :data-test-id="testId" :class="dataItemWrapperClass">
    <div :class="dataItemLabelClass">{{ label }}</div>
    <Tooltip v-if="wrapValue && value" :label="String(value)">
      <div :class="valueClasses">{{ displayValue }}</div>
    </Tooltip>
    <div v-else :class="valueClasses">{{ displayValue }}</div>
  </div>
</template>
